import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MediaComponent } from '@shared/components/media/media.component';
import { map } from 'rxjs';
import { MediaContainer } from '@core/models/atomics.model';
import { DEVICE_SIZE } from '@core/models/deviceSize.model';
import { DeviceService } from '@shared/tools/device.service';
import { CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';

@Component({
  selector: 'cx-logo',
  templateUrl: './cx-logo.component.html',
  styleUrls: ['./cx-logo.component.scss'],
  imports: [AsyncPipe, MediaComponent],
})
export class CxLogoComponent {
  protected data = inject<{ logo: MediaContainer }>(CX_ABSTRACT_COMPONENT_DATA);
  protected deviceService = inject(DeviceService);
  protected logo$ = this.deviceService.onResize$.pipe(
    map(() => {
      if (this.deviceService.isScreenSizeAtLeast(DEVICE_SIZE.DESKTOP)) {
        return this.data.logo.desktop;
      }
      return this.data.logo.mobile;
    }),
  );
}
